export default {
  faqTitle: 'Sompo Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Sompo Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'SompoSigortaCompulsoryTraffic'
      },
      {
        id: 2,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'SompoSigortaMotorInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
        path: 'SompoSigortaDaskInsurance'
      },
      {
        id: 4,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'SompoSigortaHomeInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building  fa-2x mr-2',
        path: 'SompoSigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'SompoSigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI ',
        class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
        path: 'SompoSigortaTransportation'
      },

      {
        id: 8,
        title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
        path: 'SompoSigortaComplementaryHealth'
      },
      {
        id: 9,
        title: 'YABANCI SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-user-md fa-2x mr-2',
        path: 'SompoSigortaForeignHealtInsurance'
      },
      {
        id: 10,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'SompoSigortaTravelHealthInsurance'
      },
      {
        id: 11,
        title: 'DOĞUM SİGORTASI',
        class: 'company--btn--icons fas fa-birthday-cake fa-2x mr-2',
        path: 'SompoSigortaBirthInsurance'
      }
    ]
  },
  introContent: {
    title: 'Sompo Sigorta Hakkında',
    content: [
      {
        paragraph:
          'Sigorta şirketi dengeli büyümesi ve üstün başarısı ile sigortacılık sektöründe Dünya’nın en güçlü sigorta pazarı olan Japonya‘nın dev grubu Sompo Insurance’in dikkatini çekmeyi başaran sigorta şirketidir. '
      },
      {
        paragraph:
          '2010’da Fiba Sigorta’nın hisseleri Sompo Insurance‘a devrolmuştur. 2011 tarihinde ise ünvanı Sompo Sigorta ve sonrasında Sompo Japan Sigorta Anonim Şirketi olarak güncellenmiştir. '
      },
      {
        paragraph:
          'En iyi hizmeti sunma vizyonu ile ilerleyen şirket, Sompo Japan Sigorta olarak unvan değişikliği ile beraber yükselen başarı oranlarında devamlılık göstermiştir. Sompo Sigorta oto sigortalarındaki mükemmeliyet merkezi seçilerek dünya çapında da başarı yakalamıştır.  Türkiye’de de başarısı artarak devam ederken, başarı grafiğini sürekli yükselten sigorta şirketi 2018 sonu toplam poliçe üretimlerinde 6. Sırada olurken , %5,5 pazar payına sahip olmuştur. '
      }
    ]
  },
  questions: [
    {
      title: 'Sompo Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Sompo Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Sompo Sigorta’dan teklif almak isteyen tüm müşterilerimiz alokasko.com sayfamızdan minimum fiyat avantajları ile en iyi tekliflere ulaşabilir.',
          subList: null
        },
        {
          paragraph:
            'Şirketimiz bünyesinde size özel teklif verebileceğimiz sigorta ürünlerimiz;',
          subList: [
            'Trafik Sigortası',
            'Araç Kasko Sigortası',
            'DASK (Zorunlu Deprem Sigortası)',
            'Konut Sigortası',
            'İşyeri Sigortası',
            'Ferdi Kaza Sigortası',
            'Nakliyat Sigortası',
            'Tamamlayıcı Sağlık Sigortası',
            'Seyahat Sağlık Sigortası',
            'Yabancı Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            'Sompo Sigorta’nın hizmet verdiği tüm sigorta çeşitlerinden ihtiyaç duyduğunuz ürünler için sigorta uzmanlarımızdan fiyat teklifi isteyebilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sadece uygun sigorta fiyatları ile yanınızda olmayan Sompo Sigorta, trafikte karşılaşabileceğiniz hasarlarda da yanınızdadır. Üçüncü şahıslara vereceğiniz maddi ve bedeni hasarları Sompo Trafik Sigorta ile güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu trafik sigortası poliçenizi ister <strong><em><u>peşin</u></em></strong> ister kredi kartına <strong><em><u>taksit</u></em></strong> imkanı ile satın alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Trafik sigorta teminat limitleri her yıl düzenlenerek Hazine Müsteşarlığı tarafından belirlenir. Bu kapsamda sunulan teminatlar ise;',
          subList: null
        },
        {
          paragraph: 'Araç Başına Maddi Giderler ',
          subList: [
            'Kaza başına maddi giderler',

            'Kişi başına sağlık giderleri',

            'Kaza başına sağlık giderleri',

            'Kişi başına sakatlanma ve ölüm',

            'Kaza başına sakatlanma ve ölüm teminatıdır.'
          ]
        },
        {
          paragraph:
            'Size özel sunacağımız Sompo Trafik Sigortası Fiyatını değerlendirmek için teklif al formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Mini kasko, aylık kasko, marka kasko ve geniş kapsamlı kasko sigortası ile ürün çeşitliliğini arttıran Sompo Sigorta ile aracınız bütçenize uygun şekilde güvence altında.',
          subList: null
        },
        {
          paragraph:
            'Araç kasko sigortası, sigortalı aracı güvence altına almaktadır. Teminat altına alınan sigortalı aracın kaza yapması, yanması, çalınması veya çalınmaya teşebbüs edilmesi sonucunda oluşabilecek zararları poliçe kapsamı dahilinde koruma altına alan araç sigortasıdır. ',
          subList: null
        },
        {
          paragraph:
            'Trafikte veya park halinde araçlar beklenmedik zamanlarda hasar alabilir. Kasko sigortası ile oluşabilmesi muhtemel riskleri güvence altına alabilir ve bütçenizi olası maliyetlere karşı koruyabilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Sompo Kasko Sigortası Hizmetleri:',
          subList: [
            'Aracın Çekilmesi',
            'Aracın Kurtarılması ',
            'Kiralık Araç Hizmeti ',
            'Lastik Değiştirilmesi ',
            'Yol Kenarı Yardım Hizmetleri '
          ]
        },
        {
          paragraph:
            '** Bu hizmetlerden kasko poliçeniz kapsamında yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası ile depremin neden olabileceği maddi zararlar ve deprem sonucunda oluşabilecek risk durumları güvence altına alınmaktadır. Kanunen yaptırılması zorunlu olan deprem sigortasını Sompo Sigorta’dan yaptırarak olası riskleri karşı binanızı güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph: 'Sompo DASK poliçesi kapsamında;',
          subList: [
            'Deprem Hasarları',
            'Deprem Sonucu Yer Kayması ',
            'Deprem Sonucu İnfilak ',
            'Deprem Sonucu Yangın Hasarları karşılanır.'
          ]
        },
        {
          paragraph:
            'DASK hesaplama işlemi için teklif al formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Konut paket sigortası evinizi ve eşyalarınızı birçok riske karşı güvence altına almaktadır. Sunulan farklı paket içeriği sayesine ihtiyaç kapsamınızı belirleyerek, en iyi poliçeyi satın alabilirsiniz. ',
          subList: null
        },
        {
          paragraph: '<strong>Sompo Konut Sigortası Kapsamında:</strong>',
          subList: [
            'Atı Konut Sigortası',
            'İklim Sigortası',
            'Konut Eşya Paketi',
            'Mini Konut Sigortası'
          ]
        },
        { paragraph: 'Sunulmaktadır.', subList: null },
        {
          paragraph:
            '4 Farklı konut poliçesi sunan Sompo Sigorta’nın planlarını detaylı incelemek için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta İş Yeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'İş yeri paket sigortası, iş yerinizi tek bir pakette güvence altına almaktadır. Sompo Sigorta ile sunulan iş yeri sigortasının avantajlı teminatları:',
          subList: [
            'Alternatif iş yeri masrafları',
            'Dâhili su teminatı',
            'Dolu teminatı',
            'Duman teminatı',
            'Enkaz kaldırma masrafları',
            'Fırtına teminatı',
            'Geçici adres nakli',
            'Grev, lokavt, kargaşa, halk hareketleri, kötü niyetli hareketler, terör',
            'Hava taşıtları çarpması',
            'İş durması teminatı',
            'İş yeri binasındaki sabit kıymetlerdeki hırsızlık',
            'Kar ağırlığı teminatı',
            'Kara taşıtları çarpması',
            'Kiracının-malikin kira kaybı',
            'Temeller',
            'Yangın sorumluluk (Kiracı/malik, komşuluk)',
            'Yangın, yıldırım, infilak',
            'Yer kayması teminatı.'
          ]
        },
        {
          paragraph:
            'Bu teminatların dışında poliçenize ekleyebileceğiniz birçok ek teminat bulunmaktadır. Detaylı inceleme için teklif almanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sompo Sigorta Ferdi Kaza Sigortası gündelik hayatta karşılaşabileceğiniz kaza durumlarına karşı sizi ve ailenizi teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Sompo Ferdi Kaza Sigortası Ürünleri;</strong>',
          subList: [
            'Artı Ferdi Kaza Sigortası',
            'Öğrenim Güvencesi',
            'Çağdaş Koruma Planı',
            'Ailem Güvence Planı'
          ]
        },
        {
          paragraph: '<strong>Sompo Ferdi Kaza Sigortası Teminatları;</strong>',
          subList: [
            'Vefat Teminatı',
            'Daimi Maluliyet Teminatı',
            'Gündelik Teminat ',
            'Tedavi Masrafları Teminatı'
          ]
        },
        {
          paragraph:
            '***Hem sevdiklerinizi hem de kendinizi olası kaza durumlarına karşı Sompo Sigorta güvencesinde teminat altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sompo Sigorta Nakliyat Sigortası, taşıma yapılan ürünlere gelebilecek zararları güvence altına almaktadır. Farklı teminat ve plan seçeneği sayesinde ihtiyacınıza yönelik en iyi poliçeyi bulmanız kolaylaşmıştır.',
          subList: null
        },
        {
          paragraph:
            '<strong>Nakliyat Sigortası Kapsamında Sunulan Sompo Sigorta Ürünleri:</strong>',
          subList: [
            'Yat Sigortası ',
            'Tekne İnşaat Sigortası',
            'Yurt İçi Taşıyıcı Sorumluluk Sigortası',
            'Emtea Nakliyat Sigortası',
            'Nakliyat Sertifika',
            'Online Nakliyat Sigortası'
          ]
        },
        {
          paragraph:
            '**İncelemek istediğiniz nakliyat ürünü için teklif almanız yeterlidir. Teklif formunu doldurmanız sonucunda sigorta danışmanlarımız sizlere dönüş yaparak, en doğru teminatların yer aldığı teklifleri iletecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sompo Tamamlayıcı Sağlık Sigortası, anlaşmalı olduğu SGK kapsamındaki özel hastanelerden sigortalılarına fark ücreti ödettirmeden hizmet almalarını ve muayene olmalarını sağlar. Yüksek hastane masraflarına karşı yaptırabileceğiniz tamamlayıcı sağlık sigortası ile sağlık risklerini güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong>Tamamlayıcı Sağlık Sigortası Kapsamında Sunulan Sompo Sigorta Ürünleri:</strong>',
          subList: [
            'Tamamlayıcı Sağlık Sigortası',
            'Tamamlayıcı Sağlık Doğum Paket Sigortası'
          ]
        },
        {
          paragraph:
            '** Poliçe kapsamında sunulan yatarak tedavi teminatından yararlanacağınız hizmetler yüzde 100 ve limitsiz karşılanır. Ayakta tedavi teminatından ise poliçe süreniz boyunca 10 defa yararlanma hakkınız bulunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Yurt İçi Seyahat ve Yurt Dışı Seyahatleriniz Sompo Sigorta ile güvence altında!',
          subList: null
        },
        {
          paragraph:
            'Planladığınız seyahatlerinizde oluşabilecek riskleri güvence altına Sompo Sigorta Seyahat Sağlık Sigortası teminatlarını değerlendirerek güvencenizi hemen başlatabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yurt İçi Seyahat Sağlık Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Tıbbi Tedavi Teminatı ',
            'Sigortalının Tıbbi Nedenlerle Nakli Ve/Veya Geri Dönüş Seyahati ',
            'Bagaj Kaybı veya Çalınması ',
            'Sigortalının Cenazesinin Nakli ',
            'Sigortalının Daimi İkametgaha Nakli ',
            'Tıbbi Danışmanlık Hizmeti',
            'Acil Mesajların İletilmesi ',
            'Katılımcının Tur İptali ',
            'Acente İflas Durumu',
            'Taahhüdün Yerine Getirilmemesi güvence altındadır.'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Yurt Dışı Seyahat Sağlık Sigortası Ürünleri:</u></em></strong>',
          subList: [
            'COVID-19 (Koronavirüs) Yurt Dışı Seyahat Sigortası',
            'Yurt Dışı Vize Seyahat Sigortası',
            'Elit Yurt Dışı Seyahat Sigortası',
            'Ekstrem Sporlar Seyahat Sigortası',
            'Nakliyat Şoförleri Seyahat Sigortası',
            'Yurt Dışı Eğitim Seyahat Sigortası',
            'Türkiye Vizesi Seyahat Sigortası',
            'Kısa Süreli Vize Seyahat Sigortası',
            'Hac Umre Seyahat Sigortası'
          ]
        },
        {
          paragraph:
            '**Yurt dışı güvencesi sağlayan ürünlerin detayını karşılaştırmak için AloKasko uzmanlarından fiyat teklifi talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Yabancı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Herkes İçin Sağlık Sigortası ismiyle adlandırılan yabancı sağlık sigortası, Türkiye’de ikamet izni gerektiren sigorta kapsamında ve sigorta süresi içinde sigorta ettirenin bir hastalıkla karşılaşması ya da kazaya uğraması durumunda teminat sağlamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Yabancılar için hazırlanmış bu plan kapsamında Sompo Sigorta geniş hastane ağından sigortalılarını yararlandırmaktır.',
          subList: null
        },
        {
          paragraph:
            'Poliçe fiyatlarında anlaşmalı kredi kartlarına özel 8 taksit imkânı da sunulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sompo Japan poliçe sorgulaması yapmak, Alokasko ile çok kolay!',
          subList: null
        },
        {
          paragraph:
            'Poliçe sorgulaması yapmak istediğiniz sigorta branşını teklif formundan seçin ve avantajlı fiyat tekliflerini karşılaştırarak, online satın alın.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sompo Sigorta hasar dosya sorgulaması yapmak isteyen sigortalılar 0850 250 81 81 iletişim numarasını arayarak Sompo Genel Merkez’den destek alabilir. Online hasar dosyası sorgulamak için Sompo Sigorta’nın resmi web sitesini ziyaret ederek, “<strong> <em><u>Hasar İşlemleri</u></em></strong>” menüsünden “<strong><em><u>Hasarınız Ne Durumda</u></em></strong>” sayfasına giriş yaparak, dosya numarası ya da ihbar numarası ile sorgulamasını gerçekleştirebilir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta poliçesini <strong><em><u>alokasko.com</u></em></strong> üzerinden satın alan sigortalılarımız ise 0216 371 67 77 iletişim numarasını arayarak sigorta danışmanlarımızdan sorgulama yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Sompo Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Sompo Japan poliçe fiyatlarını değerlendirmek, Alokasko ile çok kolay!',
          subList: null
        },
        {
          paragraph:
            'Sompo Japan fiyat sorgulaması yapmak isteyen adaylar, tercih edeceğini sigorta branşının teklif formunu doldurabilir ve en uygun sigorta fiyatlarını karşılaştırabilir.',
          subList: null
        }
      ]
    }
  ]
}
